import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import Select, { SelectProps, SelectOptionType } from '../Select';

type UnformSelectProps = SelectProps & {
  name: string;
};

const UnformSelect: React.FC<UnformSelectProps> = ({ name, ...rest }) => {
  const selectRef = useRef(null);

  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (rest.isMulti) {
          if (!ref.state.value) {
            return [];
          }

          return ref.state.value.map(
            (option: SelectOptionType) => option.value,
          );
        }
        if (!ref.state.value) {
          return '';
        }

        return ref.state.value.value;
      },
      setValue: (ref: any, value: SelectOptionType) => {
        ref.onChange(value);
      },
      // Sem clearValue (e sem `path`), o reset() do unform ignora este campo e
      // o select fica preenchido enquanto os inputs em volta são limpos.
      clearValue: (ref: any) => {
        ref.onChange(rest.isMulti ? [] : null);
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  return (
    <Select
      ref={selectRef}
      defaultValue={defaultValue}
      error={error}
      {...rest}
    />
  );
};

export default UnformSelect;
